import { IRootState } from '../../../store'
import { IHospitalNotifyOptionsState } from '../store/options.types'

export const getHospitalNotifyOptionsSelector = (state: IRootState): IHospitalNotifyOptionsState =>
  state.options.hospitalNotifyOptions
